import { downloadReportsPack } from '../../actions/download-report-page.acions';

const mapStateToThis = ({ downloadReportPage }) => {
  const { isLoading, error } = downloadReportPage;
  return {
    isLoading,
    error,
  };
};

const mapDispatchToThis = {
  downloadReportsPack,
};

@Inject('$state', '$ngRedux', 'gettextCatalog', 'Notifications')
export class DownloadPageController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.token = this.$state.params.token;
    this.errorMsg = '';
  }

  $onInit() {
    if (!this.token) {
      this.errorMsg = this.gettextCatalog.getString('Missing token. Please click again the link from email you have received.');
      return;
    }

    return this.downloadReportsPack(this.token);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/modules/download-report-page/components/download-page/download-page-controller.js